/**
 * The pieces every /wireline-slickline screen draws the same way.
 *
 * IMPORTED, not copied: the register, chips, badge, panel, field and input are
 * the NDT screens' (which import the downhole ones), so the verticals stay one
 * shape. Nothing in those files is edited by this vertical.
 */
import React from 'react';

export {
  NdtBadge as WlBadge,
  NdtChip as WlChip,
  NdtChipRow as WlChipRow,
  NdtDialog as WlDialog,
  NdtEmpty as WlEmpty,
  NdtField as WlField,
  NdtFormError as WlFormError,
  NdtLoading as WlLoading,
  NdtPanel as WlPanel,
  NdtRegister as WlRegister,
  NdtSpec as WlSpec,
  NDT_INPUT as WL_INPUT,
  NDT_PRIMARY as WL_PRIMARY,
  NDT_SECONDARY as WL_SECONDARY,
  isNotFound,
  type NdtColumn as WlColumn,
} from '../ndt-inspection/NdtBits';
export { DH_BAND_SECONDARY as WL_BAND_SECONDARY } from '../downhole/DownholeBits';

export const WL_EYEBROW = 'Wireline & slickline';

export { WL_RAIL, WL_SOUR_SKIN } from '../../lib/wireline-slickline';

/** The small in-panel button the crew and item editors use. */
export const WL_SMALL_BTN =
  'inline-flex items-center gap-1.5 rounded-fi-control border border-fieldiq-border bg-fieldiq-card px-2.5 py-1.5 text-xs font-semibold text-fieldiq-text hover:text-white disabled:opacity-60';

/** A non-blocking warning line: says something worth checking, never disables anything. */
export function WlWarning({ message, testId }: { message: string | null; testId?: string }) {
  if (!message) return null;
  return (
    <p data-testid={testId} className="rounded-fi-control border border-fi-signal-amber/40 bg-fi-signal-amber/10 px-3 py-2 text-sm text-fieldiq-text">
      {message}
    </p>
  );
}
